import { createSlice } from "@reduxjs/toolkit";
import { update } from "lodash";

export const initialState = {
  error: false,
  errorMessage: "",
  userDetails: {},
  loading: {
    read: false,
    profilePicUpdate: false,
    update: false,
    passwordChange: false
  }
};

const ProfileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    getuserDetails(state, action) {
      state.userDetails = action.payload;

      state.loading.read = false;
    },

    errorMessages(state, action) {
      state.error = true;
      state.errorMessage = action.payload;
    },
    hideErrorMessage(state) {
      console.log("actionCalled")
      state.error = false;
      state.errorMessage = "";
    },
    setLoading(state, action) {
      const { type, value } = action.payload;
      state.loading[type] = value;
    },
  },
});

export const {
  getuserDetails,
  hideErrorMessage,
  setLoading , 
  errorMessages
} = ProfileSlice.actions;

export default ProfileSlice.reducer;
